'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { loginWithSso } from '../../actions/ssoLogin';

const SingleSignOnButton = ({
  email,
  loginPortalId,
  loginRedirectUrl,
  history
}) => {
  const dispatch = useDispatch();

  const onSubmitLoginWithSso = () => {
    dispatch(loginWithSso({
      email,
      loginPortalId,
      loginRedirectUrl,
      history
    }));
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "sso-login-button",
      id: "ssoBtn",
      type: "button",
      use: "tertiary",
      className: "m-top-4 width-100",
      onClick: onSubmitLoginWithSso,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.form.sso.loginButton"
      })
    })
  });
};

SingleSignOnButton.propTypes = {
  email: PropTypes.string,
  loginPortalId: PropTypes.string,
  loginRedirectUrl: PropTypes.string,
  history: PropTypes.instanceOf(Object)
};
export default SingleSignOnButton;